import React from 'react';

import { Avatar, IconButton } from '@mui/material';
import i18next from 'i18next';

import { Dropdown, INPUT_WIDTH, InputIncrement } from '@commons/utils/styledLibraryComponents';

import Text, { ENUM_COLORS, ENUM_FONTS } from '@commons/Text';

import {
  BadgeContainer,
  IconActionContainer,
  NameCellContainer,
  NameSkuContainer,
  RemoveIconContainer,
} from './customCellsStyle';

const DEFAULT_IMAGE_URL = '/images/inpulse/supplier-product-photo-placeholder.svg';

export const renderNameCell = (row) => (
  <NameCellContainer>
    <Avatar
      alt="supplier-product-image"
      src={row.img || DEFAULT_IMAGE_URL}
      sx={{
        width: 40,
        height: 40,
      }}
    />
    <NameSkuContainer>
      <Text font={ENUM_FONTS.TEXT_BIG_HEIGHT_16}>{row.name}</Text>
      <Text color={ENUM_COLORS.DGREY} font={ENUM_FONTS.TEXT_SMALL_HEIGHT_16}>
        {row.sku}
      </Text>
    </NameSkuContainer>
  </NameCellContainer>
);

export const renderDropdownCell = (items, selectedItem, onSelectionChange, disabled = false) => (
  <Dropdown
    customListStyle={{ position: 'fixed' }}
    isDisabled={disabled}
    items={items}
    selectedItem={selectedItem}
    width={INPUT_WIDTH.MEDIUM}
    isRequired
    onSelectionChange={onSelectionChange}
  />
);

export const renderInputCell = (row, onChange, disabled = false) => (
  <InputIncrement
    hasErrors={row.quantity <= 0}
    isDisabled={disabled}
    limitValues={{ min: 0 }}
    setValue={onChange}
    value={row.quantity}
    onChange={onChange}
  />
);

export const getIconActions = ({ seePicture, replacePicture, deletePicture }) => [
  {
    id: 'see-picture',
    render: (
      <IconActionContainer>
        <img alt="see-picture" src="/images/inpulse/open-in-fullscreen-black.svg" />
        <Text>{i18next.t('GENERAL.SEE_PICTURE')}</Text>
      </IconActionContainer>
    ),
    handleClick: seePicture,
  },
  {
    id: 'replace-picture',
    render: (
      <IconActionContainer>
        <img alt="replace-picture" src="/images/inpulse/add-a-photo-black.svg" />
        <Text>{i18next.t('GENERAL.REPLACE_PICTURE')}</Text>
      </IconActionContainer>
    ),
    handleClick: replacePicture,
  },
  {
    id: 'delete-picture',
    render: (
      <IconActionContainer>
        <img alt="delete-picture" src="/images/inpulse/trash-black.svg" />
        <Text>{i18next.t('GENERAL.DELETE_PICTURE')}</Text>
      </IconActionContainer>
    ),
    handleClick: deletePicture,
  },
];

export const removeItemCell = (row, handleItemRemoval) => (
  <RemoveIconContainer>
    <IconButton
      alt="remove-item"
      aria-haspopup="true"
      sx={{
        '&:hover': {
          '& .remove-icon': {
            filter:
              'invert(71%) sepia(94%) saturate(382%) hue-rotate(120deg) brightness(94%) contrast(94%)',
          },
        },
      }}
      onClick={() => handleItemRemoval(row)}
    >
      <Avatar
        alt="remove-item"
        className="remove-icon"
        src={'/images/inpulse/close-black-small.svg'}
        sx={{
          width: 16,
          height: 16,
        }}
      />
    </IconButton>
  </RemoveIconContainer>
);

export const renderBadgeCell = () => (
  <BadgeContainer>
    <Avatar
      alt="open-picture"
      className="picture"
      src={'/images/inpulse/sync-black-small.svg'}
      sx={{
        width: 8,
        height: 8,
      }}
    />
  </BadgeContainer>
);
